import React from "react";
import ReactDOM from "react-dom/client";
import "@/fonts.css";
import "@/index.css";
import App from "@/App";

// The shell ships a default title/description for crawlers that do not run JS; drop them before Helmet
// adds the page-specific ones so rendered pages never carry two title or description tags.
document.querySelector('meta[name="description"]:not([data-rh])')?.remove();
document.querySelector("head > title")?.remove();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
